import React, { Component } from 'react';
import { connect } from 'react-redux';

class Color extends Component {
  render() {
    let colorValues = [];
    let prodcolor;
    if (this.props.colorValue && this.props.colorValue.colorList) {
      this.props.colorValue.colorList.map((colorValueitems, index) => {
        if (colorValueitems.name) {
          prodcolor = colorValueitems.name.replace(/\s/g, '');
        } else {
          prodcolor = colorValueitems.name;
        }
        colorValues.push(
          <div>
            <div>
              <input
                className="value"
                id={colorValueitems.name}
                type="checkbox"
                name={colorValueitems.name}
                checked={this.props.preSelection('color', colorValueitems.name)}
                onClick={() => this.props.action('color', colorValueitems.name, 'show-filter')}
                aria-label={colorValueitems.name + ' ' + colorValueitems.count + ' ' + 'items'}
                onKeyPress={() => this.props.action('color', colorValueitems.name, 'show-filter')}
              />
              <label for={colorValueitems.name}>
                <span
                  className={'product-color bg-' + prodcolor.toLowerCase()}
                  style={{ paddingTop: '0px', paddingRight: '15px', paddingBottom: '3px', marginRight: '3px' }}
                ></span>
                <span className="bg-black" style={{ backgroundColor: colorValueitems.name }}></span> {colorValueitems.name} ({colorValueitems.count})
              </label>
              {/* <input className="value" id={colorValueitems.name} type="checkbox" 
                        name={colorValueitems.name} checked={this.props.preSelection("color",colorValueitems.name)}
                        onClick={()=>this.props.action("color",colorValueitems.name)} aria-label={colorValueitems.name+colorValueitems.count+"items"} onKeyPress={()=>this.props.action("color",colorValueitems.name)}/>
                        <label for={colorValueitems.name} role="checkbox" aria-checked="false" >
                        <span className={"product-color bg-"+ prodcolor.toLowerCase()} style={{ paddingTop: "0px",paddingRight: "15px",paddingBottom: "3px" ,marginRight: "3px"}} ></span>
                        <span className="bg-black" style={{backgroundColor:colorValueitems.name}} 
                        ></span> {colorValueitems.name} ({colorValueitems.count})</label> */}
            </div>
          </div>,
        );
      });
    }
    return (
      <React.Fragment>
        <div>
          <div className="m_accordion-details m_single" style={{ display: this.props.showColor ? 'none' : 'block' }}>
            <div className="no-bullet margin-bottom-zero">{colorValues}</div>
          </div>
        </div>
      </React.Fragment>
    );
  }
}
const mapStateToProps = (state) => {
  return {
    cartProduct: state.cartProductDataVTP,
    filterDataValue: state.productsVTP.filterData,
  };
};
export default connect(mapStateToProps)(Color);
